import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";
import { Toast } from "shared";
import { TOAST_TYPES_ENUM } from "enums";
import { queryClient } from "App";
import { CompanyStoreType } from "types/CompanyTypes";

type StoreCompanyPayload = CompanyStoreType & { invoice?: File | null };

export const useStoreCompany = (
  options?: UseMutationOptions<any, Error, StoreCompanyPayload>
) => {
  return useMutation({
    ...options,
    mutationKey: ["storeCompany"],
    mutationFn: async (data: StoreCompanyPayload) => {
      const formData = new FormData();

      Object.entries(data).forEach(([key, value]) => {
        if (value === null || value === undefined) return;

        if (key === "invoice") {
          if (value instanceof File) {
            formData.append("invoice", value);
          }
          return;
        }

        formData.append(key, String(value));
      });

      return axiosInstance
        .post("/companies", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: "Trwa dodawanie spółki...",
        type: TOAST_TYPES_ENUM.LOADING,
        id: "store-company",
      });
      if (options && options.onMutate) {
        // @ts-ignore
        return options.onMutate(variables);
      }
    },
    onSuccess: async (data, variables, context) => {
      Toast({
        message: "Spółka dodana pomyślnie.",
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: "store-company",
      });
      await queryClient.invalidateQueries({
        queryKey: ["companies"],
        refetchType: "all",
      });
      await queryClient.invalidateQueries({ queryKey: ["investments/grouped"] });
      await queryClient.invalidateQueries({ queryKey: ["investments/summary"] });
      await queryClient.invalidateQueries({ queryKey: ["investments/admin/summary", "reliance"] });
      await queryClient.invalidateQueries({ queryKey: ["investments/admin/summary", "other"] });
      if (options && options.onSuccess) {
        await options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: "Błąd podczas dodawania spółki.",
        type: TOAST_TYPES_ENUM.ERROR,
        id: "store-company",
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default useStoreCompany;
